import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, inrFormatter, numberFormat, responsivefy} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(res => {
        let data = res.data
        // main svg
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', 3 * chart.width / 2)
            .attr('height', chart.height)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(50,10)')

        var g = svg.append('g')     // move right 20px.

        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)


        // x-scale and x-axis

        var x1Scale = d3.scaleLinear()
            .domain([0, d3.max(data.map(function (d) {
                return d.metric1;
            }))])
            .range([0, d3.max(data.map(function (d) {
                return d.metric1 / (d.metric1 / 600);
            }))]);

        var x1AxisLabel = d3.axisTop().scale(x1Scale).ticks(8).tickFormat(inrFormatter);

        console.warn(x1AxisLabel)

        // Setting up a way to handle the data
        var tree = d3.cluster()               // This D3 API method setup the Dendrogram datum position.
            .size([chart.height, chart.width - 460])    // Total width - bar chart width = Dendrogram chart width
            .separation(function separate(a, b) {
                return a.parent === b.parent            // 2 levels tree grouping for category
                || a.parent.parent === b.parent
                || a.parent === b.parent.parent ? 3.5 : 3.8
            })

        var stratify = d3.stratify()            // This D3 API method gives csv file flat data array dimensions.
            .id(function (d) {
                return d.dim1_name
            })
            .parentId(function (d) {
                return d.dim1_name.substring(0, d.dim1_name.lastIndexOf('^'))
            })


        console.log("dend", name)

        var root = stratify(data)
        tree(root)


        // Draw every datum a line connecting to its parent.
        var link = g.selectAll('.link')
            .data(root.descendants().slice(1))
            .enter()
            .append('path')
            .attr('class', 'link-dendogram')
            .style('fill', function (d) {
                return metric1ColorScale(d.data.dim1_name)
            })
            .attr('d', function (d) {
                return 'M' + d.y + ',' + d.x
                    + 'C' + (d.parent.y + 100) + ',' + d.x
                    + ' ' + (d.parent.y + 100) + ',' + d.parent.x
                    + ' ' + d.parent.y + ',' + d.parent.x
            })
            .style("stroke", "#555")
            .style("stroke-opacity", "0.4")
            .style("stroke-width", "1px");

        console.warn(link)

        // Setup position for every datum; Applying different css classes to parents and leafs.
        var node = g.selectAll('.node')
            .data(root.descendants())
            .enter()
            .append('g')
            .attr('class', function (d) {
                return 'node' + (d.children ? ' node--internal' : ' node--leaf')
            })
            .attr('transform', function (d) {
                return 'translate(' + d.y + ',' + d.x + ')'
            })

        // Draw every datum a small circle.
        node.append('circle')
            .attr('r', 4)
            .style('fill', (d) => {
                return metric1ColorScale(d.data.dim1_name)
            })

        // Setup G for every leaf datum.
        var leafNodeG = g.selectAll('.node--leaf')
            .append('g')
            .attr('class', 'node--leaf-g')
            .attr('transform', 'translate(' + 8 + ',' + -13 + ')')
            .style('fill', 'black')

        leafNodeG.append('rect')
            .attr('class', 'shadow')
            .style('fill', (d) => {
                return d.data.dim1_name.endsWith('Allocated') ? "#6baed6"
                    : d.data.dim1_name.endsWith('Spent') ? "#fcae91"
                        : metric1ColorScale(d.data.dim1_name)
            })
            .attr('width', 2)
            .attr('height', 30)
            .attr('rx', 2)
            .attr('ry', 2)
            .transition()
            .duration(800)
            .attr('width', (d) => {
                return x1Scale(d.data.metric1)
            })


        leafNodeG.append('text')
            .attr('dy', 19.5)
            .attr('x', 8)
            .style('text-anchor', 'start')
            .attr("font-size", "20px")
            .text(function (d) {
                return d.data.dim1_name.substring(d.data.dim1_name.lastIndexOf('^') + 1) + ': ' + ' ' + numberFormat(d.data.metric1)
            })

        // Write down text for every parent datum
        var internalNode = g.selectAll('.node--internal')
        internalNode.append('text')
            .attr('y', -10)
            .style('text-anchor', 'middle')
            .attr("font-size", "20px")
            .style('fill', 'black')
            .text(function (d) {
                return d.data.dim1_name.substring(d.data.dim1_name.lastIndexOf('^') + 1)
            })

        // Attach axis on top of the first leaf datum.
        var firstEndNode = g.select(".node--leaf");
        firstEndNode.insert("g")
            .attr("class", "xAxis")
            .attr("transform", "translate(" + 7 + "," + -14 + ")")
            .call(x1AxisLabel);


        // The moving ball
        var ballG = svg.insert("g")
            .attr("class", "ballG")
            .attr("transform", "translate(" + 1700 + "," + chart.height / 2 + ")");

        ballG.insert("rect")
            .attr("class", "shadow")
            .style("fill", "steelblue")
            .attr("width", 100)
            .attr("height", 50)

        ballG.insert("text")
            .style("text-anchor", "middle")
            .attr("dy", 5)
            .text("0.0");

        // Animation functions for mouse on and off events.
        d3.selectAll(".node--leaf-g")
            .on("mouseover", handleMouseOver)
            .on("mouseout", handleMouseOut);

        function handleMouseOver(d) {
            var leafG = d3.select(this);
            console.log(leafG)
            var ballGMovement = ballG.transition()
                .duration(400)
                .attr("transform", "translate(" + (d.y
                        + x1Scale(d.data.metric1) - 50) + ","
                    + (d.x + 1.5) + ")");

            ballGMovement.select("rect")
                .style('fill', function () {
                    return d.data.dim1_name.endsWith('Allocated') ? "#6baed6"
                        : d.data.dim1_name.endsWith('Spent') ? "#fcae91"
                            : metric1ColorScale(d.data.dim1_name)
                })
                .attr("width", 500)
                .attr("height", 30)


            ballGMovement.select("text")
                .delay(100)
                .attr("y", 18)
                .style("text-anchor", "start")
                .attr("font-size", "20px")
                .text(function () {
                    const name = d.data.dim1_name.split('^')
                    return name[4] != null ? name[1] + " || " + name[2] + " || " + name[3] +
                        " || " + name[4] + colonAnnotation + inrFormatter(d.data.metric1)
                        : name[3] != null ? name[1] + " || " + name[2] + " || " + name[3] + colonAnnotation + inrFormatter(d.data.metric1)
                            : name[1] + " || " + name[2] + colonAnnotation + inrFormatter(d.data.metric1)
                })


        }

        function handleMouseOut() {
            var leafG = d3.select(this);

            leafG.select("rect")
                .attr("stroke-width", "0")

        }
    })
}
